import { ConversionApiService } from './service/ConversionApiService';

export const conversionApiService: ConversionApiService = new ConversionApiService();
